import Component from '@glimmer/component';

import { modifier } from 'ember-modifier';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

interface CircularProgressSignature {
  Args: {
    progress: number;
    thickness?: number;
  };
  Element: SVGElement;
}

const bem = getBem(styles);

const updateProgress = modifier(
  (element: SVGCircleElement, [progress]: [number]) => {
    const radius = element.r.baseVal.value;
    const circumference = radius * 2 * Math.PI;

    element.style.strokeDasharray = `${circumference} ${circumference}`;
    element.style.strokeDashoffset = `${circumference}`;

    const offset = circumference - (progress / 100) * circumference;
    element.style.strokeDashoffset = `${offset}`;
  },
);

export class CircularProgress extends Component<CircularProgressSignature> {
  // Getter and setter
  get thickness() {
    return this.args.thickness ?? 16;
  }

  get radius() {
    return (120 - this.thickness) / 2;
  }

  // Template
  <template>
    <svg viewBox='0 0 120 120' class={{(bem)}} ...attributes>
      <circle
        class={{bem 'ring'}}
        r={{this.radius}}
        cx='60'
        cy='60'
        stroke-width={{this.thickness}}
        {{updateProgress @progress}}
      />
    </svg>
  </template>
}
